import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddConversationsPopup from "./AddConversationsPopup";


interface ConversationsEmptyPageProps {
  onConversationsCreated?: (newConversations: any) => void;
}


export default function ConversationsEmptyPage({
  onConversationsCreated,
}: ConversationsEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Conversations"
      colorKey="interactions"
      AddPopupComponent={AddConversationsPopup}
      onEntityCreated={onConversationsCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select an Conversation",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Conversation",
          openPopup: true, 
        },
        {
          id: "send",
          type: "text",
          text: "Log Conversations",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Conversation History",
          direction: "down",
        },
      ]}
    />
  );
}
